import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IContactPersonResponse, ImmomioIconName } from '@resident-nx/shared';
import { NgTemplateOutlet } from '@angular/common';
import { ContactDetailsWebComponent } from '../../contact-details/contact-details.component';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { IconWebComponent, ImageWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-direct-assignment',
  templateUrl: './ticket-direct-assignment.component.html',
  styleUrl: './ticket-direct-assignment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    ImageWebComponent,
    IconWebComponent,
    NgTemplateOutlet,
    ImmomioButtonComponent,
    ContactDetailsWebComponent,
  ],
})
export class TicketDirectAssignmentComponent {
  public title = input.required<string>();
  public contacts = input.required<IContactPersonResponse[]>();
  public selectedContact = signal<IContactPersonResponse | undefined>(undefined);
  protected readonly ImmomioIconName = ImmomioIconName;
  #activeOffCanvas = inject(NgbActiveOffcanvas);

  public dismiss() {
    this.#activeOffCanvas.dismiss();
  }
}
